import {makeAutoObservable} from 'mobx';
import Gender from 'enum/CompanyGender';

class CompanyStore {
    gender = Gender.Male;
    name = '';
    mobilephone = '';
    email = '';

    constructor() {
        makeAutoObservable(this)
    }
}

export default new CompanyStore();
